import { __decorate } from "tslib";
import $ from 'jquery';
import { throttle } from 'helpful-decorators';
import { Breakpoint } from '../../types/breakpoint';
import { getCurrentBreakpoint } from '../../utils/breakpoint';
const CONTENT_SELECTOR = '.js__same-height-content';
const BREAKPOINTS_FROM_NAME = {
    xs: Breakpoint.xs,
    sm: Breakpoint.sm,
    md: Breakpoint.md,
    lg: Breakpoint.lg,
    xl: Breakpoint.xl,
};
const DEFAULT_GROUP_NAME = '__default__';
export default class ContentSameSize {
    static init() {
        if (!$(CONTENT_SELECTOR).length) {
            return;
        }
        this.setContentHeight();
        $(window).on('resize', this.handleResize.bind(this));
        $(window).on('load', this.setContentHeight.bind(this));
    }
    static handleResize() {
        this.setContentHeight();
    }
    static setContentHeight() {
        const $content = $(CONTENT_SELECTOR);
        const groups = [];
        const currentBreakpoint = getCurrentBreakpoint();
        $content.each((index, element) => {
            $(element).css('min-height', '');
        });
        $content.each((index, element) => {
            const $element = $(element);
            const group = String($element.data('group-name') || DEFAULT_GROUP_NAME);
            const sameHeightFrom = String($element.data('same-height-from') || '');
            if (groups.some(item => item.group === group && item.sameHeightFrom === sameHeightFrom)) {
                return;
            }
            groups.push({
                group,
                sameHeightFrom,
                depth: $element.parents(CONTENT_SELECTOR).length,
            });
        });
        groups
            .sort((leftGroup, rightGroup) => rightGroup.depth - leftGroup.depth)
            .forEach(({ group, sameHeightFrom }) => {
            const minBreakpoint = this.getMinBreakpoint(sameHeightFrom);
            if (minBreakpoint !== null && currentBreakpoint < minBreakpoint) {
                return;
            }
            const $groupElements = $content.filter((index, element) => {
                const $element = $(element);
                return (String($element.data('group-name') || DEFAULT_GROUP_NAME) === group &&
                    String($element.data('same-height-from') || '') === sameHeightFrom);
            });
            let groupHeight = 0;
            $groupElements.each((index, element) => {
                const elementHeight = $(element).outerHeight() || 0;
                if (elementHeight > groupHeight) {
                    groupHeight = elementHeight;
                }
            });
            $groupElements.css('min-height', groupHeight);
        });
    }
    static getMinBreakpoint(sameHeightFrom) {
        return BREAKPOINTS_FROM_NAME[sameHeightFrom.toLowerCase()] ?? null;
    }
}
__decorate([
    throttle(300)
], ContentSameSize, "handleResize", null);
